import { render, staticRenderFns } from "./Promobar.vue?vue&type=template&id=a1ece266&scoped=true&"
import script from "./Promobar.vue?vue&type=script&setup=true&lang=js&"
export * from "./Promobar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Promobar.vue?vue&type=style&index=0&id=a1ece266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ece266",
  null
  
)

export default component.exports